import "core-js/stable"
import "regenerator-runtime/runtime"
import { StrictMode } from "react"
import { render } from "react-dom"
import { Router } from "./components/Pages/Router"
import { makeServer } from "./services/Mirage"
import { SentryInit } from "sentry"
import { history } from "./HistoryUtill"
import "./index.css"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FontsLoader } from "./components/Shared/FontsLoader"

if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_API_URL === "http://localhost/api/v1"
) {
  makeServer(process.env.NODE_ENV)
}

if (process.env.REACT_APP_SENTRY_DSN) {
  SentryInit(
    process.env.REACT_APP_SENTRY_DSN,
    process.env.REACT_APP_SENTRY_ENV ?? process.env.NODE_ENV,
    history
  )
}

const queryClient = new QueryClient()

render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <FontsLoader>
        <Router />
      </FontsLoader>
    </QueryClientProvider>
  </StrictMode>,
  document.getElementById("root")
)
